module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('swiper', {
    attrs: {
      "options": _vm.swiperOpt
    }
  }, [_vm._l((_vm.data), function(item) {
    return _c('swiper-slide', {
      key: item.id
    }, [_c('a', {
      attrs: {
        "href": item.origin_url,
        "target": "_blank"
      }
    }, [_c('h3', {
      staticClass: "swiper-title px3 center"
    }, [_vm._v(_vm._s(item.title))])]), _c('div', {
      staticClass: "swiper-img"
    }, [_c('img', {
      style: ({
        width: '100%',
        height: '100%'
      }),
      attrs: {
        "src": _vm.shift(item.o_pic_list[0])
      }
    })])])
  }), _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62766004","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Swiper.vue
// module id = 992
// module chunks = 1